import { html, nothing } from "lit";
import type { LlmStatsTabId } from "../controllers/llm-stats-scope.ts";

export const LLM_STATS_TABS: Array<{
  id: LlmStatsTabId;
  label: string;
  icon: string;
  desc: string;
}> = [
  {
    id: "connect",
    label: "Connect",
    icon: "⬡",
    desc: "Providers, API keys, and discovered models",
  },
  { id: "overview", label: "Overview", icon: "◈", desc: "Local capacity & model usage" },
  {
    id: "analytics",
    label: "Analytics",
    icon: "📊",
    desc: "Cost breakdown, trends & provider budgets",
  },
  { id: "fleet", label: "Fleet spend", icon: "⬡", desc: "Network node cost breakdown" },
  { id: "sessions", label: "Sessions", icon: "◈", desc: "Session-by-session token & cost" },
  { id: "trace", label: "Trace", icon: "◈", desc: "Agent cycle span trace for selected session" },
  {
    id: "local",
    label: "Local LLM",
    icon: "⬢",
    desc: "Ollama status, installed models, and read-only activity console",
  },
];

export type LlmStatsTabsProps = {
  activeTab: LlmStatsTabId;
  onTabChange: (tab: LlmStatsTabId) => void;
};

export function renderLlmStatsTabs(props: LlmStatsTabsProps) {
  return html`
    <div class="llm-stats-tabs-container">
      <div class="llm-stats-tabs-bar" role="navigation" aria-label="LLM Stats views">
        ${LLM_STATS_TABS.map(
          (tab) => html`
            <button
              type="button"
              role="tab"
              class="llm-stats-tab ${props.activeTab === tab.id ? "active" : ""}"
              aria-selected=${props.activeTab === tab.id}
              id="llm-stats-tab-${tab.id}"
              data-testid=${`llm-stats-tab-${tab.id}`}
              @click=${() => props.onTabChange(tab.id)}
            >
              <span class="llm-stats-tab-icon">${tab.icon}</span>
              <span class="llm-stats-tab-label">${tab.label}</span>
              ${
                props.activeTab === tab.id
                  ? html` <span class="llm-stats-tab-indicator"></span> `
                  : nothing
              }
            </button>
          `,
        )}
      </div>
    </div>
  `;
}
